<script>
import service from '@/service';
import * as Ladda from 'ladda';
const IMG_PH_TEXT = 'Izberi ali povleci datoteko ...';

export default {
	name: 'nalozi-datoteko',
	components: {
	},
	methods: {
		showModal: function (showFrom, data, multiple) {
			this.clearForm();
			this.showFrom = showFrom;
			this.modalData = data;
			this.$refs.modal.show();
		},
		modal_okClick: function (evt) {
			evt.preventDefault();
			let loader = Ladda.create(this.$refs.aOk);
			loader.start();
			if (this.showFrom === 'mapa') {
				service.uploadFilesForMapa(this.import_files, this.modalData)
					.then(result => {
						loader.stop();
						this.$emit('success', result);
						this.$refs.modal.hide();
						this.clearForm();
					})
					.catch(error => {
						loader.stop();
						this.showError('Napaka!');
						if (error) {
							console.log(error);
						}
					});
			} else {
				this.showError('Neznani upload');
			}
		},
		modal_cancelClick: function (evt) {
			evt.preventDefault();
			this.clearForm();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearForm();
			}, 300);
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function () {
			this.modalTitle = '';
			this.modalCancelTitle = '';
			this.modalIsBusy = false;
			this.showFrom = null;
			this.modalData = null;
			this.multipleFiles = null;
			this.import_files = null;
			this.message.type = null;
			this.message.text = null;
		}
	},
	watch: {
	},
	data: function () {
		return {
			modalTitle: '',
			modalCancelTitle: 'Prekliči',
			modalErrorMsg: null,
			modalIsBusy: false,
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			showFrom: null,
			modalData: null,
			multipleFiles: false,
			import_files: null
		}
	},
	computed: {
		modalTitle_text () {
			if (this.showFrom === 'mapa') {
				return 'Nalaganje datoteke';
			}
			return 'Neznano nalaganje';
		},
		ok_text () {
			return 'Naloži'
		},
		upload_placeholder () {
			return IMG_PH_TEXT;
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" class="modal-primary" @ok="modal_okClick" :title="modalTitle_text" :ok-title="ok_text" :cancel-title="modalCancelTitle" :busy="modalIsBusy">
			<b-row>
				<b-col v-if="showFrom === 'mapa'">
					<b-col>
						<b-form-file 
							multiple
							v-model="import_files"
							:placeholder="upload_placeholder"
							drop-placeholder="Povleci datoteko..."
							></b-form-file>
					</b-col>
				</b-col>
				<b-col v-else>
					Klic iz neznanega view-a/modala
				</b-col>
			</b-row>
		
		<b-alert class="error_message" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button variant="secondary" @click="modal_cancelClick($event)">Prekliči</b-button>
						<b-button ref="aOk" variant="primary" data-style="zoom-in" @click.stop="modal_okClick($event)">
							<span class="ladda-label">{{ ok_text }}</span>
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style scoped>
@import '../../../node_modules/ladda/dist/ladda-themeless.min.css';

.b_table {
	margin-bottom: o;
}
.ma_pos {
	text-align: end;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
</style>
<style>
.no_padding {
	padding: 0;
	margin: 0;
}
.custom-file-input ~ .custom-file-label::after {
	content: 'Izberi';
}
.updateDataButton {
	float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/NaloziDatotekoModal.vue